var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddReaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5564 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5564 20.25 12C20.25 11.434 20.1931 10.882 20.085 10.3492C20.0026 9.94326 20.2648 9.54739 20.6708 9.46499C21.0767 9.38259 21.4726 9.64487 21.555 10.0508C21.6829 10.6812 21.75 11.3332 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C12.6165 2.25 13.2204 2.30732 13.8063 2.41713C14.2134 2.49343 14.4816 2.88532 14.4053 3.29245C14.329 3.69957 13.9371 3.96776 13.53 3.89146C13.0347 3.79864 12.5234 3.75 12 3.75Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C16.5523 13 17.0104 13.4522 16.9013 13.9936C16.4405 16.279 14.4212 18 12 18C9.57879 18 7.55953 16.279 7.09873 13.9936C6.98957 13.4522 7.44772 13 8 13H16Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1818 9.27271C10.1818 10.2769 9.36775 11.0909 8.36359 11.0909C7.35944 11.0909 6.54541 10.2769 6.54541 9.27271C6.54541 8.26856 7.35944 7.45453 8.36359 7.45453C9.36775 7.45453 10.1818 8.26856 10.1818 9.27271Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4547 9.27271C17.4547 10.2769 16.6407 11.0909 15.6365 11.0909C14.6324 11.0909 13.8184 10.2769 13.8184 9.27271C13.8184 8.26856 14.6324 7.45453 15.6365 7.45453C16.6407 7.45453 17.4547 8.26856 17.4547 9.27271Z",
    className: "Icon-fill-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 1C20.75 0.585786 20.4142 0.25 20 0.25C19.5858 0.25 19.25 0.585786 19.25 1V3.25H17C16.5858 3.25 16.25 3.58579 16.25 4C16.25 4.41421 16.5858 4.75 17 4.75H19.25V7C19.25 7.41421 19.5858 7.75 20 7.75C20.4142 7.75 20.75 7.41421 20.75 7V4.75H23C23.4142 4.75 23.75 4.41421 23.75 4C23.75 3.58579 23.4142 3.25 23 3.25H20.75V1Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReaction);
export default __webpack_public_path__ + "static/media/AddReaction.34b67a53d7fea683d605cdbf31eb04d0.svg";
export { ForwardRef as ReactComponent };